import { request } from '@services'
import { i18n } from '@plugins/i18n'
import { STATUS_REQUEST } from '@utils/constant'

export const state = {
  agentAdmin: {},
  status: null,
  loading: false,
  errors: null,
}

export const getters = {
  getAgentAdmin(state) {
    return state.agentAdmin
  },
  getStatus(state) {
    return state.status
  },
  getErrors(state) {
    return state.errors
  },
}

export const mutations = {
  SET_AGENT_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_AGENT_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.agentAdmin = newData
    state.errors = null
  },
  SET_AGENT_LIST_RECEIVED_FAIL(state, error) {
    state.loading = false
    state.errors = error
  },
  SET_ADMIN_LIST_AGENTADMIN_REQUESTED(state) {
    state.loading = true
  },
  SET_ADMIN_LIST_AGENTADMIN_RECEIVED(state) {
    state.loading = false
    state.status = STATUS_REQUEST.SUCCESS
    state.errors = null
  },
  SET_ADMIN_LIST_AGENTADMIN_FAILED(state, errors) {
    state.loading = false
    state.status = STATUS_REQUEST.FAILED
    state.errors = errors
  },
  RESET_ADMIN_LIST_AGENTADMIN_FAILED(state) {
    state.loading = false
    state.status = null
    state.errors = null
  },
}

export const actions = {
  async fetchingAgentAdmin({ commit }, params) {
    commit('SET_AGENT_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/admin/get/',
        payload: { ...params },
      })
      commit('SET_AGENT_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_AGENT_LIST_RECEIVED_FAIL', error)
    }
  },
  async editAgentAdmin({ commit }, params) {
    commit('SET_ADMIN_LIST_AGENTADMIN_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/admin/edit/',
        payload: {
          ...params,
          exit_message: i18n.t('agent.default_exit_message'),
        },
      })
      commit('SET_ADMIN_LIST_AGENTADMIN_RECEIVED')
      return response
    } catch (error) {
      commit('SET_ADMIN_LIST_AGENTADMIN_FAILED', error)
    }
  },
  resetAgentAdmin({ commit }) {
    commit('RESET_ADMIN_LIST_AGENTADMIN_FAILED')
  },
}
